// extracted by css-extract-rspack-plugin
export default {"cls1":"Configuration-cls1__Fm","cls2":"Configuration-cls2_SxV Configuration-cls1__Fm"};